import React, { Component } from 'react';
import { connect } from 'react-redux';
import { timeFormat } from '../../../itrust_common/components/HelperFunctions'
import { tabChange } from '../../../itrust_common/redux/actions/otherActions'
import { appointmentSelectedSlot } from '../../../redux/actions/public/AppointmentActions'
import * as $ from 'jquery'

class TimeSlots extends Component {
  handleSelectedTimeSlot(slot) {
    this.props.dispatch(tabChange({ anonymous: 2 }))
    this.props.dispatch(appointmentSelectedSlot(slot))
  }
  mouseover(index, color) {
    $(`#btn-${index}`).css({ "background-color": `${color}`, "border-color": `${color}`, "color": 'white' })
  }
  mouseout(index, color) {
    $(`#btn-${index}`).css({ "background-color": "white", "border-color": `${color}`, "color": `${color}` })
  }

  renderPublicStoreSlot(item, parentIndex) {
    const { availableSlots, anonymousSetting: { button_and_link_color }, store } = this.props
    return (
      <div className='col-12 my-2'>
        <h6 className='mb-2'>{item}</h6>
        {Object.values(availableSlots[item])?.length === 0 && <p className='mb-0'>No available appointments</p>}
        {Object.values(availableSlots[item]).map((slot, index) => <button id={`btn-${parentIndex}-${index}`}
          className="btn btn-sm mx-2 my-3"
          style={{ color: `${button_and_link_color}`, borderColor: `${button_and_link_color}`, backgroundColor: 'white' }}
          onMouseOver={this.mouseover.bind(this, `${parentIndex}-${index}`, button_and_link_color)}
          onMouseOut={this.mouseout.bind(this, `${parentIndex}-${index}`, button_and_link_color)}
          aria-disabled="true"
          onClick={this.handleSelectedTimeSlot.bind(this, slot)}>
          {timeFormat(slot.start_time, store.timezone)}
        </button>
        )}
      </div>
    )
  }

  render() {
    const { isFirstAvailable, availableSlots, storeTimezone, anonymousSetting: { button_and_link_color }, store } = this.props
    return (
      <div className="col-5 col-md-6 text-left pl-7 py-6">
        <h6>Select appointment time slot for booking.</h6>
        <small className="my-3">All times are shown in {storeTimezone}.</small>
        <div className="d-flex flex-row flex-wrap mt-3 overflow-auto max-height-23">
          {Object.values(availableSlots).length === 0 ?
            <strong> Please select another date there is no available appointments. </strong> :
            <>
              {
                isFirstAvailable ? <div className='row'>
                  {Object.keys(availableSlots).map((item, index) => this.renderPublicStoreSlot(item, index))}
                </div> :
                  <>
                    {Object.values(availableSlots).map((slot, index) =>
                      <button id={`btn-${index}`}
                        className="btn btn-sm mx-2 my-3"
                        style={{ color: `${button_and_link_color}`, borderColor: `${button_and_link_color}`, backgroundColor: 'white' }}
                        onMouseOver={this.mouseover.bind(this, index, button_and_link_color)}
                        onMouseOut={this.mouseout.bind(this, index, button_and_link_color)}
                        aria-disabled="true"
                        onClick={this.handleSelectedTimeSlot.bind(this, slot)}>
                        {timeFormat(slot.start_time, store.timezone)}
                      </button>
                    )}
                  </>
              }
            </>
          }
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  const { publicStaff, publicStore, publicStore: { isFirstAvailable } } = state
  return {
    isFirstAvailable,
    availableSlots: isFirstAvailable ? publicStore.slots : publicStaff.slots,
    stores: publicStore.stores,
    store: publicStore.store
  };
};

export default connect(mapStateToProps)(TimeSlots);